export enum CreditCardRewardsType {
  MYCRUISE_POINTS = "mycruise_points",
  AMEX_MR = "amex_mr",
  HILTON = "hilton",
  IHG = "ihg",
  MILES = "miles",
  AVIOS = "avios",
  MARRIOTT_BONVOY = "marriott_bonvoy",
  WELLS_FARGO = "wells_fargo",
  HYATT = "hyatt",
  NORWEGIAN_CRUISE_POINTS = "norwegian_cruise_points",
  DISNEY_REWARDS_DOLLARS = "disney_rewards_dollars",
  FRONTIER = "frontier",
  POINTS = "points",
  WYNDHAM = "wyndham",
  BREEZEPOINTS = "breezepoints",
  ALASKA = "alaska",
  UNKNOWN = "unknown",
  TRAVEL = "travel",
  CAPITAL_ONE = "capital_one",
  JETBLUE = "jetblue",
  UNITED = "united",
  CASH_BACK = "cash_back",
  SOUTHWEST = "southwest",
  AIRLINE = "airline",
  AMERICAN = "american",
  BILT_REWARDS = "bilt_rewards",
  CHASE_UR = "chase_ur",
  HAWAIIAN = "hawaiian",
  CHOICE = "choice",
  CITI_TYP = "citi_typ",
};